import { createTrignometryOperator } from "./_internal";
const $atan = createTrignometryOperator(Math.atan);
export {
  $atan
};
